module.exports = __webpack_public_path__ + "../static/media/formatoPC.dc9bbc19.jpg";